export default __webpack_public_path__ + "static/media/GermaniaOne-Regular.9f89c9c6.ttf";